<template>
  <div class="panel-body">
    <div class="">
      <div class="">
        <fieldset class="border current-plan">
          <legend class="border">現在の最大商品登録可能数</legend>
          <dl class="row text-center">
            <br>
            <dd class="col-sm-6"><h3>{{maxListingAmount}}商品</h3></dd>
            <dd class="col-sm-6" style="margin-top: 8px;"><button class="btn btn-info w-120" @click.prevent="openInfoModal">詳細</button></dd>
          </dl>
        </fieldset>
      </div>
      <div class="mr-t-10">
        <fieldset class="border choose-plan">
          <legend class="border">商品数の追加</legend>
          <p class="description">追加する商品数を選択して下さい。</p>
          <div class="select-plan m-t">
            <div class="radio" v-for="(plan, index) in planList" :key="index">
              <div class="row plan">
                <div class="col-sm-3 plan-block pd-t-15 pd-b-15">
                  <input type="radio" :value="plan.salMonPlanScript" :id="'plan' + index" v-model="planSelected">
                  <label :for="'plan' + index" v-html="plan.salMonPlanName"></label>
                </div>
                <div class="col-sm-3 plan-block pd-t-15 pd-b-15">
                  <span v-if="plan.salMonPlanAmount">¥{{plan.salMonPlanAmount}} (税込み)</span>
                </div>
                <div class="col-sm-6 plan-block pd-t-15 pd-b-15">
                  <span v-html="plan.salMonPlanDescription"></span>
                </div>
              </div>
            </div>
            <div class="row mr-t-30">
              <div class="col-sm-12">
                <p>※「クレジット決済」 ボタンを押すと、カード決済システム【Stripe】の決済画面へ移動します</p>
              </div>
            </div>
          </div>
          <div class="update-btn">
            <button class="btn btn-info w-200" :disabled="!planSelected" @click.prevent="openModal">売上金から支払う</button>
            <button class="btn btn-info w-120" :disabled="!planSelected" @click="doCheckout">クレジット決済</button>
          </div>
        </fieldset>
      </div>
      <info-modal v-if="showModalInfo" @close="closeInfoModal" :data="infoList" :totalAmount="maxListingAmount"></info-modal>
      <modal-confirm v-if="showModalConfirm" @confirm="handleSubmit" @close="closeModal" :message="planUpdateMessage"></modal-confirm>
    </div>
  </div>
</template>

<script>
import PlanService from '@/services/planservice'
import ModalConfirm from '@/components/ModalConfirm'
import InfoModal from '@/components/ListingInfoModal'
import Util from '@/common/utility'
import msg from '@/common/msg'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ModalConfirm,
    InfoModal
  },
  data () {
    return {
      planSelected: null,
      planList: [],
      currentPlan: null,
      error: null,
      loader: null,
      isPrepareData: true,
      alertMessage: null,
      showModalConfirm: false,
      showModalInfo: false,
      planUpdateMessage: null,
      maxListingAmount: 0,
      infoList: []
    }
  },
  async created () {
    await this.getMyPlan()
    await this.getAllPlans()
  },
  computed: {
    salmonPlanName () {
      if (this.isPrepareData) return ''
      return this.currentPlan ? this.currentPlan.salMonPlanName : 'No current plan'
    }
  },
  methods: {
    async getAllPlans () {
      const self = this
      await PlanService.getAllPlans()
        .then(data => {
          // self.currentPlan = data.salmonPlan.currentPlan
          self.planList = data.salmonPlan.avaiablePlans
          self.planList.map(plan => {
            plan.salMonPlanAmount = Util.formatMoney(plan.salMonPlanAmount)
          })
        })
        .catch(err => {
          self.error = err
        })
        .finally(() => {
          self.isPrepareData = false
          if (this.$route.params.tab === 'service-info') {
            this.$events.fire('done')
          }
        })
    },
    async getMyPlan () {
      const self = this
      await PlanService.getMyPlan()
        .then(data => {
          self.maxListingAmount = data.maxListingAmount
          self.infoList = data.data
        })
        .catch(err => {
          self.error = err
        })
    },
    openModal () {
      const selectedPlan = this.planList.filter(plan => plan.salMonPlanScript === this.planSelected)[0]
      // this.planUpdateMessage = '<p>プランを' + this.currentPlan.salMonPlanName + 'から' + selectedPlan.salMonPlanName + 'に変更します。</p>'
      this.planUpdateMessage = `<p>商品数追加に必要な金額：¥${selectedPlan.salMonPlanAmount}(税込み) を売上からマイナスをいたします。</p>`
      this.planUpdateMessage = this.planUpdateMessage + '<p>追加後に商品数を元に戻すことはできません。</p>'
      this.showModalConfirm = true
    },

    closeModal () {
      $('#confirm-alert').modal('hide')
      this.showModalConfirm = false
    },

    async handleSubmit () {
      this.closeModal()
      const selectedPlan = this.planList.filter(plan => plan.salMonPlanScript === this.planSelected)[0]
      let logParams = {
        name: eventCode.settings.service_info_tab.click_payment_from_revenue_button,
        properties: {
          itemQuantityAdded: selectedPlan.salMonPlanName
        }
      }
      EventService.postTrackLog(logParams)

      const currentAmount = this.maxListingAmount
      const addAmount = selectedPlan.salMonPlanUpperlimit
      PlanService.updatePlanBySales(selectedPlan.salMonPlanScript)
        .then((response) => {
          this.defaultPaymentInfo = {...this.paymentInfo}
          this.planSelected = null

          this.getMyPlan()

          this.$store.commit('toggleModal', {
            show: true,
            message: 'お支払いありがとうございます。<br/>商品数が追加されました。<br/>最大商品登録可能数: ' + currentAmount + ' + ' + addAmount + ' = ' + (currentAmount + addAmount)
          })
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },

    async doCheckout () {
      const self = this
      const selectedPlan = this.planList.filter(plan => plan.salMonPlanScript === this.planSelected)[0]
      let logParams = {
        name: eventCode.settings.service_info_tab.click_payment_credit_button,
        properties: {
          itemQuantityAdded: selectedPlan.salMonPlanName
        }
      }
      EventService.postTrackLog(logParams)

      if (self.planSelected) {
        self.loader = this.$loading.show()

        await PlanService.getCheckoutSession({ sku: self.planSelected })
          .then(response => {
            if (response && response.data) {
              location.href = response.data
            }
          })
          .catch(error => {
            this.$store.commit('toggleModal', {
              show: true,
              message: error
            })
          })
          .finally(() => {
            self.loader && self.loader.hide()
          })
      } else {
        this.$store.commit('toggleModal', {
          show: true,
          message: msg.selectPlanWarn
        })
      }
    },
    openInfoModal () {
      this.showModalInfo = true
      let logParams = {
        name: eventCode.settings.service_info_tab.click_detail_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    },
    closeInfoModal () {
      this.showModalInfo = false
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'service-info') {
      let logParams = {
        name: eventCode.settings.service_info_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/setting/ServiceInfo.vue